import React from "react";
import TextImage from "./Text-image";
import pope from "../images/Pope.jpg";
import wall from "../images/wall.png";
import map from "../images/map.jpeg";
import dome from "../images/dome.jpg";
import merge from "../images/Belvedere.png";

function Introduction() {
  console.log(pope);

  return (
    <div id="Home">
      <section className="content">
        <div className="image-container-left">
          <img src={pope} alt="" />
          <p className="caption">
            Attrib. Caradosso Foppa, Medal of Julius II, bronze, 1503. Courtesy
            National Gallery of Art, Washington
          </p>
        </div>

        <div className="text text-container-right white-background">
          <p>
            History best remembers Julius II as the "Warrior Pope." His reign,
            from 1503 to 1513, was marred by spiritual and political unrest. The
            pontiff famously rode into battle with papal troops and faced down
            threats of schism from within the Vatican's curia. Julius's
            legendary terribilità, however, not only describes the pope's
            militance, but also his literary and artistic patronage. His court
            hosted the peninsula's great scholars, poets, and artists -- among
            them, Michelangelo and Raphael, whose Vatican works are celebrated
            examples of Italian Renaissance art. When Raphael arrived in Rome in
            1508, he began to paint the walls of the Bibliotheca Iulia, Julius
            II's private library, with frescoes of the School of Athens
            (representing Philosophy), the Disputa (Theology), the Parnassus
            (Poetry), and the Jurisprudence (Law), showing authors and books
            that Julius read. Today called the Stanza della Segnatura, this room
            once was the real and symbolic center of the papal apartments. After
            centuries of conflict, renovation, and reuse, however, it is
            difficult to picture the Stanza as it originally was: a vibrant site
            where Raphael's paintings framed Julius's collected books, and
            conversations about pictures and texts flourished.{" "}
          </p>
          <br></br>
        </div>
      </section>

      <TextImage
        string1="right"
        string2="left"
        object3={wall}
        caption="Preliminary concept: Bibliotheca Iulia Instaurata"
        string4="This project re-envisions the Stanza as the library of Julius II. In so doing, it reanimates these conversations by allowing visitors today to explore the visual and literary parallels that once wedded Raphael's magnificent paintings to the books that were shelved below them. Designed for students, scholars, and curious explorers alike, the platform is an immersive educational environment, allowing users to step into the shoes of the Renaissance scholars, diplomats, and prelates that once visited the space. We invite you to join this digital Stanza as reader, viewer, and interlocutor, to peruse its histories, and to reconsider its contents. What does the Bibliotheca Iulia reveal about word and image in sixteenth-century Rome? And what might these conversations tell us about learning, then and now? "
      />

      <section className="content">
        <div className="image-container-left">
          <img src={map} alt="" />
          <p className="caption">
            <a
              style={{ color: "#717171" }}
              href="https://harvardartmuseums.org/collections/object/297665"
            >
              The Cortile del Belvedere under construction, c. 1552-3. Photo ©
              President and Fellows of Harvard College
            </a>
          </p>
        </div>

        <div className="text text-container-right white-background">
          <h4>The Stanza della Segnatura in the Vatican Palace Complex</h4>
          <br></br>
          <p>
            {" "}
            The room we call the Stanza della Segnatura was at the heart of Pope
            Julius II's plans for the medieval Vatican Palace. This was the
            second of three small, vaulted chambers on the palace's third floor,
            which Julius had chosen, after his election as pope, to take and
            remake as his personal apartments. The structure of this wing of the
            palace, built in the mid-1400s by Pope Nicholas V, was renovated,
            likely by Julius' favored architect, Donato Bramante, and painting
            there must have begun by late 1508: the twenty-six-year-old Raphael,
            newly arrived in Rome, received his first payment for painting in
            what the receipt calls "the vaulted room in the middle" on 13
            January 1509. After completing the Stanza della Segnatura in 1511,
            Raphael was commissioned to paint the two flanking rooms as well,
            first the one to the east, the Stanza d'Eliodoro, and then the one
            to the west, the Stanza dell'Incendio, both named after the frescoes
            Raphael painted in them. At the time of his death in 1520, Raphael
            was painting the larger room at the east end of this wing, the Sala
            di Costantino, for Julius' successor, Pope Leo X.
          </p>
          <br></br>
        </div>
      </section>

      <TextImage
        string1="right"
        string2="left"
        object3={merge}
        string4="All three rooms had windows on their north walls, allowing views onto another major building project Julius had initiated, the Cortile del Belvedere, a terraced courtyard designed by Bramante to stretch a thousand feet from the Vatican Palace to another fifteenth-century structure, the Villa Belvedere.  Raphael's painted Parnassus, with its muses and music-making Apollo, frames this view towards the Villa Belvedere where in 1511 Julius installed ancient sculptures such as the Apollo Belvedere.  The pope added windows to the south walls of the Stanza della Segnatura and the adjoining Stanza d'Eliodoro, opening into a small interior courtyard known as the Cortile del Pappagallo, perhaps for the aviary that he also had built in the palace. "
      />

      <TextImage
        string1="left"
        string2="right"
        object3={dome}
        caption="Credit: Steven Zucker, Smarthistory
            "
        string4="Julius's plans for the Vatican complex were ambitious, including not only these spaces but also the remaking of the nearby basilica of Saint Peter's.  Raphael referenced that massive undertaking twice in his frescoes: the enormous unseen dome in the School of Athens is like the one Bramante was planning for New Saint Peter's, and the distant scene of construction on the hill behind the theologians on the left side of the Disputa reflects the ongoing work of building the new basilica."
      />
    </div>
  );
}

export default Introduction;
